import type { ReactElement } from 'react';
import { IconBrandApple, IconBrandGoogle } from '@tabler/icons-react';
import { ButtonPreset } from '@/constants/componentPresets';
import { ColorType } from '@/theme/colors';
import { FontWeight } from '@/theme/typography';
import { Cbutton } from '../Cbutton';
import { Ctext } from '../Ctext';
const AUTH_PROVIDER_ICON_COLOR = 'white';
const AUTH_CONNECTING_LABEL = 'Connecting...';
const APPLE_AUTH_LABEL = 'Authenticate via Apple';
const GOOGLE_AUTH_LABEL = 'Authenticate via Google';
const LOADING_OPACITY = 0.6;
const READY_OPACITY = 1;
const APPLE_PROVIDER_ACTION = 'apple';
const GOOGLE_PROVIDER_ACTION = 'google';
interface InitialAuthButtonsProps {
    loadingApple: boolean;
    loadingGoogle: boolean;
    loadingEmail: boolean;
    onAppleAuth: () => void;
    onGoogleAuth: () => void;
}
interface ProviderLabelInput {
    isLoading: boolean;
    readyLabel: string;
}
interface ProviderButtonViewModelInput {
    loadingApple: boolean;
    loadingGoogle: boolean;
    loadingEmail: boolean;
}
interface ProviderButtonViewModel {
    disabled: boolean;
    appleLabel: string;
    googleLabel: string;
    appleOpacity: number;
    googleOpacity: number;
}
function getProviderLabel({ isLoading, readyLabel }: ProviderLabelInput): string {
    if (isLoading)
        return AUTH_CONNECTING_LABEL;
    return readyLabel;
}
function getProviderOpacity(isLoading: boolean): number {
    if (isLoading)
        return LOADING_OPACITY;
    return READY_OPACITY;
}
function buildProviderButtonViewModel({ loadingApple, loadingGoogle, loadingEmail, }: ProviderButtonViewModelInput): ProviderButtonViewModel {
    return {
        disabled: [loadingApple, loadingGoogle, loadingEmail].some(Boolean),
        appleLabel: getProviderLabel({ isLoading: loadingApple, readyLabel: APPLE_AUTH_LABEL }),
        googleLabel: getProviderLabel({ isLoading: loadingGoogle, readyLabel: GOOGLE_AUTH_LABEL }),
        appleOpacity: getProviderOpacity(loadingApple),
        googleOpacity: getProviderOpacity(loadingGoogle),
    };
}
export function InitialAuthButtons({ loadingApple, loadingGoogle, loadingEmail, onAppleAuth, onGoogleAuth, }: InitialAuthButtonsProps): ReactElement {
    const viewModel = buildProviderButtonViewModel({
        loadingApple,
        loadingGoogle,
        loadingEmail,
    });
    return (
      <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '16px',
            marginTop: '13px',
            width: '100%',
        }}>
        <Cbutton preset={ButtonPreset.Secondary} onClick={onAppleAuth} disabled={viewModel.disabled} style={{ width: '100%', opacity: viewModel.appleOpacity }}>
          <div style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: '12px',
        }}>
            <IconBrandApple size={24} color={AUTH_PROVIDER_ICON_COLOR}/>
            <Ctext size={16} weight={FontWeight.Medium} color={ColorType.White} opacity={1}>
              {viewModel.appleLabel}
            </Ctext>
          </div>
        </Cbutton>

        <Cbutton preset={ButtonPreset.Secondary} onClick={onGoogleAuth} disabled={viewModel.disabled} style={{ width: '100%', opacity: viewModel.googleOpacity }}>
          <div style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: '12px',
        }}>
            <IconBrandGoogle size={24} color={AUTH_PROVIDER_ICON_COLOR}/>
            <Ctext size={16} weight={FontWeight.Medium} color={ColorType.White} opacity={1}>
              {viewModel.googleLabel}
            </Ctext>
          </div>
        </Cbutton>
      </div>
    );
}
